import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from '@/components/ui/alert-dialog';
  import { useQueryClient } from '@tanstack/react-query';
  
  export type DeleteExperimentConfirmationProps = {
    isOpen: boolean;
    handleOpen: (boolean: boolean) => void;
    experimentId: string;
    organizationId: string | undefined;
  };
  
  export const DeleteExperimentConfirmation = ({
    isOpen,
    handleOpen,
    experimentId,
    organizationId,
  }: DeleteExperimentConfirmationProps) => {
    const queryClient = useQueryClient();
    const [deletingExperiment, setDeletingExperiment] = useState(false);
  
    return (
      <AlertDialog open={isOpen} onOpenChange={handleOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete this
              experiment and remove all the data inside it from our servers.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={async e => {
                e.preventDefault();
                setDeletingExperiment(true);
                await deleteExperiment(experimentId, organizationId);
                setDeletingExperiment(false);
                handleOpen(false);
              }}
              disabled={deletingExperiment}
              className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
            >
              {deletingExperiment ? 'Processing...' : 'Continue'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
};
    